const emailToName: Record<string, string> = {
  "zzang8713@gmail.com": "장정호",
  "jws@swlogis.it.kr": "장우성",
  "cmn@swlogis.it.kr": "조미녀",
  "psj@swlogis.it.kr": "박서정",
  "gong@swlogis.it.kr": "공인준",
  "lch@swlogis.it.kr": "이창훈",
  "cjs@swlogis.it.kr": "조재순",
  "hky@swlogis.it.kr": "한계영",
  "cbs@swlogis.it.kr": "최병수",
  "jms@swlogis.it.kr": "정민선",
};

export default emailToName; 